import './Contentside.scss'

import React, {ReactFragment} from 'react'

import {Theme} from '../Theme'
import {style} from '../../util/style'

const styles = style('contentside', ['content', 'sidebar', 'fixed'])

export const Contentside: React.FC<{reverse?: boolean; bgcolor?: boolean}> = ({
	reverse,
	bgcolor,
	children
}) => {
	return (
		<div className={styles().mod({reverse}).mod({bgcolor})}>
			<Theme.Container>
				<div className={styles('row')}>{children}</div>
			</Theme.Container>
		</div>
	)
}

export const ContentsideContent: React.FC = ({children}) => (
	<div className={styles.content()}>{children}</div>
)

export const ContentsideSidebar: React.FC<{overflow?: boolean}> = ({
	overflow,
	children
}) => <div className={styles.sidebar().mod({overflow})}>{children}</div>

export const ContentsideFixed: React.FC<{className?: string}> = ({
	className,
	children
}) => <div className={styles.fixed().with(className)}>{children}</div>
